import { tabNames } from './Constants'

/**
 * Generates a style object for provider info page tabs based on the tab name and its active state.
 *
 * @param name - The name of the tab. Expected to be one of the values in `tabNames`.
 * @param isActive - Indicates whether the tab is active.
 * @returns A style object containing the width of the tab in pixels. If the tab name does not match any case, an empty object is returned.
 */
export const generateProviderInfoPageTabsWidth = (name: string, isActive: boolean): { width?: number } => {
  switch (name) {
    case tabNames.GENERAL:
      return { width: 200 }
    case tabNames.LICENSE_AND_PRODUCTIVITY:
      return { width: isActive ? 258 : 233 }
    case tabNames.CALENDAR:
      return { width: 200 }
    default:
      return {}
  }
}

type ProductivityVisitType = {
  VisitTypeId?: string | null | undefined
  customDuration?: number | undefined
  isNewCustomDurationValueWasAdded?: boolean | undefined
  isCustomDurationWasDisabled?: boolean | undefined
}

type ProductivityForEdit = {
  VisitTypes: ProductivityVisitType[]
}

export const getAdjustProductivityRequestBody = (productivityForEdit: ProductivityForEdit) => {
  const requestBodyVisitTypesForCreate = productivityForEdit.VisitTypes.filter(
    (visitType) => visitType.isNewCustomDurationValueWasAdded,
  ).map(({ VisitTypeId, customDuration }) => ({
    VisitTypeId: VisitTypeId ?? null,
    Duration: customDuration ?? 0,
  }))
  const requestBodyVisitTypesForDelete = productivityForEdit.VisitTypes.filter(
    (visitType) => visitType.isCustomDurationWasDisabled,
  )
    .map(({ VisitTypeId }) => VisitTypeId)
    .filter((visitTypeId): visitTypeId is string => typeof visitTypeId === 'string')
  return {
    Create: requestBodyVisitTypesForCreate,
    Delete: requestBodyVisitTypesForDelete,
  }
}
